import React from "react";
import { Col, Row } from "reactstrap";
import ClientDetailCard from "./detailcard";
import ClientKpiCards from "./kpicards";
import { ClientDetailDto } from "src/store/clients/type";

const ClientDashboardTab = ({ client }: { client: ClientDetailDto }) => {
  return (
    <React.Fragment>
      {/* KPI'lar künyenin ÜSTÜNDE: "bu müşteri sistemi kullanıyor mu"
          sorusu, vergi dairesi bilgisinden önce gelir. */}
      <Row className="mt-2">
        <Col>
          <ClientKpiCards clientId={client?.Id} />
        </Col>
      </Row>
      <Row>
        <Col>
          <ClientDetailCard client={client} />
        </Col>
      </Row>
    </React.Fragment>
  );
};
export default ClientDashboardTab;
